import React, { useState } from 'react'
import { XMarkIcon } from '@heroicons/react/24/solid'
import { useTranslation } from 'react-i18next'

export default function WhatsAppButton() {
  const [mensajeVisible, setMensajeVisible] = useState(true)
  const { t } = useTranslation('common')

  return (
    <div className="fixed bottom-5 right-5 z-50 flex items-center gap-3">
      {mensajeVisible && (
        <div className="relative hidden max-w-[220px] rounded-xl bg-white p-3 pr-7 text-sm font-semibold leading-5 text-navy-900 shadow-lg ring-1 ring-black/5 sm:block">
          {t('whatsapp.message')}
          <button
            type="button"
            onClick={() => setMensajeVisible(false)}
            aria-label={t('whatsapp.closeMessage')}
            className="absolute right-1 top-1 rounded-full p-1 text-gray-400 transition hover:bg-gray-100 hover:text-gray-600"
          >
            <XMarkIcon className="h-3.5 w-3.5" aria-hidden="true" />
          </button>
          <span className="absolute right-[-6px] top-1/2 h-3 w-3 -translate-y-1/2 rotate-45 bg-white ring-1 ring-black/5" aria-hidden="true" />
        </div>
      )}

      <a
        href="https://wa.me/528118649258"
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('whatsapp.chatAria')}
        title={t('whatsapp.chatAria')}
        className="flex h-14 w-14 flex-none items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition hover:scale-105 hover:bg-[#20BD5A]"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" className="h-7 w-7" aria-hidden="true">
          <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.39 1.26 4.81L2 22l5.42-1.34a9.85 9.85 0 0 0 4.62 1.17h.01c5.46 0 9.9-4.45 9.9-9.92C21.95 6.45 17.5 2 12.04 2Zm5.8 14.06c-.24.68-1.38 1.3-1.9 1.35-.5.05-.99.24-3.33-.7-2.82-1.13-4.63-3.99-4.77-4.18-.14-.19-1.14-1.52-1.14-2.9 0-1.37.72-2.05.97-2.33.25-.28.55-.35.73-.35.18 0 .37 0 .53.01.17.01.4-.06.62.48.24.58.81 2 .88 2.14.07.14.12.31.02.5-.1.19-.15.31-.29.48-.15.17-.31.38-.44.51-.15.15-.3.31-.13.6.17.28.76 1.26 1.63 2.04 1.12 1 2.06 1.31 2.35 1.46.29.14.46.12.63-.07.17-.19.71-.83.9-1.11.19-.28.38-.24.63-.14.26.09 1.65.78 1.93.92.29.14.48.21.55.33.07.12.07.68-.17 1.36Z" />
        </svg>
      </a>
    </div>
  )
}
